import React from 'react';
import WarningIcon from '../../assets/departureWifi/icon_warning.png';
import styled from 'styled-components';

type Props = {
  onClose: () => void;
  place?: 'airport' | 'port';
};

function AndroidWifiErrorModal({ onClose, place = 'airport' }: Props) {
  return (
    <DimedWindow>
      <Modal>
        <div>
          <TitleWrapper>
            <img src={WarningIcon} alt='' width={24} height={24} />
            <Title>네트워크 연결 오류</Title>
          </TitleWrapper>
          <Description>
            '설정' 앱에서 {place === 'airport' ? '공항' : '항구'} 와이파이를
            <br />
            연결 후 다시 시도해주세요.
          </Description>
        </div>
        <Button onClick={onClose}>확인</Button>
      </Modal>
    </DimedWindow>
  );
}

const DimedWindow = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 200;
`;

const Modal = styled.aside`
  width: 100%;
  max-width: 400px;
  height: 186px;
  margin: 20px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
  border-radius: 8px;
`;

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 12px;
`;

const Title = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #ed0828;
`;

const Button = styled.button`
  width: 100%;
  height: 48px;
  border-radius: 8px;
  background-color: #246cf6;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
`;

const Description = styled.p`
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: #80848a;
  margin-bottom: 16px;
  line-height: 21px;
`;

export default AndroidWifiErrorModal;
